/**
 * @generated SignedSource<<69090da11c0acfabf54278e0607774e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useTestShopifyTokenMutation$variables = {
  brandId: string;
};
export type useTestShopifyTokenMutation$data = {
  readonly testShopifyToken: {
    readonly error: string | null;
    readonly shopName: string | null;
    readonly status: {
      readonly accessTokenExpiresAt: any | null;
      readonly accessTokenLast4: string | null;
      readonly adminChangeUrl: string | null;
      readonly error: string;
      readonly refreshTokenExpiresAt: any | null;
      readonly refreshedAt: any | null;
      readonly state: string;
    };
  };
};
export type useTestShopifyTokenMutation = {
  response: useTestShopifyTokenMutation$data;
  variables: useTestShopifyTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      }
    ],
    "concreteType": "InternShopifyTokenTestResult",
    "kind": "LinkedField",
    "name": "testShopifyToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shopName",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "InternShopifyTokenStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accessTokenLast4",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accessTokenExpiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refreshTokenExpiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refreshedAt",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminChangeUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTestShopifyTokenMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTestShopifyTokenMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "fa8599ccd3070dbc13ecb7184d558f24",
    "id": null,
    "metadata": {},
    "name": "useTestShopifyTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useTestShopifyTokenMutation(\n  $brandId: ID!\n) {\n  testShopifyToken(brandId: $brandId) {\n    shopName\n    error\n    status {\n      state\n      accessTokenLast4\n      accessTokenExpiresAt\n      refreshTokenExpiresAt\n      refreshedAt\n      error\n      adminChangeUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "00e3baf512faa5bceb9ab4ac6705c8dd";

export default node;
